import { Sentry } from "@/lib/sentry";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

function FallbackUI({
  error,
  resetError,
}: {
  error: Error;
  resetError: () => void;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold">Noe gikk galt</h1>
      <p className="max-w-md text-muted-foreground">
        En uventet feil oppstod. Feilen er rapportert automatisk. Prøv å laste
        siden på nytt.
      </p>
      <p className="text-xs text-muted-foreground">{error.message}</p>
      <button
        onClick={() => {
          resetError();
          window.location.reload();
        }}
        className="rounded bg-primary px-4 py-2 text-primary-foreground"
      >
        Last på nytt
      </button>
    </div>
  );
}

export function SentryErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <FallbackUI error={error as Error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
